module.exports = __webpack_public_path__ + "video/intro.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/remote/intro.mp4
// module id = 93
// module chunks = 245 246